import { render, staticRenderFns } from "./AllowedIPs.vue?vue&type=template&id=16782b28&scoped=true"
import script from "./AllowedIPs.vue?vue&type=script&lang=js"
export * from "./AllowedIPs.vue?vue&type=script&lang=js"
import style0 from "./AllowedIPs.vue?vue&type=style&index=0&id=16782b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16782b28",
  null
  
)

export default component.exports